import { RATIO } from "../app/constants/speed";

export const valueToRate = (value: number) => value / RATIO;

export const rateToValue = (rate: number) => Math.floor(RATIO * rate);
